"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreSearchInput = _interopRequireDefault(require("@legacy-vfuk/core-search-input"));

var _coreInteractiveIcon = _interopRequireDefault(require("@legacy-vfuk/core-interactive-icon"));

var _coreAnimate = _interopRequireDefault(require("@legacy-vfuk/core-animate"));

var Styled = _interopRequireWildcard(require("./styles/SearchBar.style"));

var _focusOnElement = _interopRequireDefault(require("../../../../helpers/focusOnElement"));

var _constants = require("../../../../constants");

var _TopNavigationContext = _interopRequireDefault(require("../../../../context/TopNavigationContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SearchBar = function SearchBar() {
  var _ref = (0, _react.useContext)(_TopNavigationContext["default"]),
      secondaryNav = _ref.secondaryNav,
      setShowSearch = _ref.setShowSearch,
      showSearch = _ref.showSearch,
      animationDuration = _ref.animationDuration,
      interactionHandler = _ref.interactionHandler,
      dataAttributePrefix = _ref.dataAttributePrefix;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1];

  if (!(secondaryNav !== null && secondaryNav !== void 0 && secondaryNav.search)) return null;
  var search = secondaryNav.search;
  (0, _react.useEffect)(function () {
    var searchInput = document.getElementById(search.searchInput.id);
    if (searchInput) searchInput.focus();
  }, [showSearch]);

  var closeButtonHandler = function closeButtonHandler(event) {
    setShowSearch(false);
    setTimeout(function () {
      (0, _focusOnElement["default"])(search.id);
    }, animationDuration);
    interactionHandler(event, _constants.DataKeys.CloseSearch);
  };

  return showSearch ? /*#__PURE__*/_react["default"].createElement(Styled.SearchBar, null, /*#__PURE__*/_react["default"].createElement(_coreAnimate["default"], {
    show: showSearch,
    enter: {
      animations: ['fadeIn', 'slideFromBottom'],
      duration: animationDuration
    },
    exit: {
      animations: ['fadeOut', 'slideToBottom'],
      duration: animationDuration
    }
  }, /*#__PURE__*/_react["default"].createElement(Styled.Search, null, /*#__PURE__*/_react["default"].createElement(Styled.SearchInputWrapper, null, /*#__PURE__*/_react["default"].createElement(_coreSearchInput["default"], {
    textInput: {
      id: search.searchInput.id,
      value: searchValue,
      placeholder: search.searchInput.placeholder,
      onChange: function onChange(e) {
        return setSearchValue(e.target.value);
      }
    },
    fieldWrapper: {
      label: search.searchInput.srText,
      width: 'full',
      showLabel: false
    },
    searchIconButton: {
      srText: search.searchInput.searchIconButton.srText,
      onClick: function onClick() {
        return search.searchInput.onSearch(searchValue);
      }
    },
    onClear: function onClear() {
      return setSearchValue('');
    }
  })), /*#__PURE__*/_react["default"].createElement(Styled.CloseButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(_coreInteractiveIcon["default"], {
    srText: search.closeButton.srText,
    name: "close",
    onClick: function onClick(event) {
      closeButtonHandler(event);
    },
    htmlAttributes: {
      dataAttributes: {
        'data-selector': "".concat(dataAttributePrefix, "-").concat(_constants.DataKeys.CloseSearch)
      }
    }
  }))))) : null;
};

SearchBar.displayName = "SearchBar";
var _default = SearchBar;
exports["default"] = _default;
//# sourceMappingURL=SearchBar.js.map